module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAOVJREFUWEftljFqAkEUhr+37QrRwjQ2gQieYtfSIhDIGYSU8QaD7AUs7PQcdhait5CEQDpDEIWMnT5Z1APsTCW8qaaY759/vuaNELjyoX/lxBRQhf6qSGchURIClUzu/DfwVO4VvlZF2g7JiimwAx6ul+6XRVq3AmbADJgBM3CfBrru8KboGGiFvCCC+VH4kNz5LdCICIpB/8oCv0AzJiWC3Ujm/IugI5DHikG3UXzD9tV43SQJA/sPmAEzYAbMgBkINpA5/ynwfBlAul4WtU61YXQ5HVHgvyfIBDgmib4vhrV5SIEzLjKoUQ7Ud/wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/hsvccfg/add-plus.png
// module id = +eCo
// module chunks = 1